import { format } from 'date-fns';

import type { Locale } from '@shared/LocaleContext';

// `meta.date` is a calendar day; parse it as local midnight so it never shows
// as the day before in time zones west of UTC.
export const parseReleaseDay = (day: string): Date => {
  const [year, month, date] = day.split('-').map(Number);
  return new Date(year, month - 1, date);
};

export const formatReleaseDay = (
  day: string,
  dateLocale: Locale['dateLocale'],
): string => format(parseReleaseDay(day), 'd MMM yyyy', { locale: dateLocale });

export const formatReleaseMonth = (
  day: string,
  dateLocale: Locale['dateLocale'],
): string => format(parseReleaseDay(day), 'LLLL yyyy', { locale: dateLocale });
